import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { IScientificDegreePayload, IInitialStateScientificDegree} from "../types";
import { GetScientificDegrees } from "./thunk";

const initialState: IInitialStateScientificDegree = {
  scientificDegreeData: [],
  selectedScientificDegreeIDs:[],
  isLoadingScientificDegree: false,
  scientificDegreesRestoreData:[],
  isViewScientificDegreesRestore:false,


};

const scientificDegreeSlice = createSlice({
  name: "scientificDegree",
  initialState,
  reducers: {
    setScientificDegree: (state, action:PayloadAction<{data:IScientificDegreePayload[]}> ) => {
      const {data}  =action.payload
      state.scientificDegreeData = data
    },


    deletedScientificDegree: (state, action: PayloadAction<number>) => {
      state.scientificDegreeData  = state.scientificDegreeData.filter(
        (elem) => elem.id !== action.payload
      );
    },
    updateScientificDegree: (state, action: PayloadAction<IScientificDegreePayload>) => {
      const updateData = action.payload;

      state.scientificDegreeData = state.scientificDegreeData.map((elem) => {
        if (elem.id === updateData.id) {
          return {
            ...elem,
            ...updateData,
          };
        }
        return elem;
      });
    },
    setIsViewScientificDegreesRestore:(state)=>{

      state.isViewScientificDegreesRestore =!state.isViewScientificDegreesRestore;
    },

    setScientificDegreesRestoreData:(state, action) => {
      state.scientificDegreesRestoreData = action.payload;
    },
    deletedRestoreScientificDegrees:(state,action)=>{
      state.scientificDegreesRestoreData  = state.scientificDegreesRestoreData.filter(
          (elem) => elem.id !== action.payload
      );
    },
    setSelectedScientificDegreeIDs: (state, action) => {
      state.selectedScientificDegreeIDs=action.payload
    },


  },
  extraReducers: (builder) => {
    builder
      .addCase(GetScientificDegrees.pending, (state) => {
        state.isLoadingScientificDegree = true;
      })
      .addCase(GetScientificDegrees.fulfilled, (state) => {
        state.isLoadingScientificDegree = false;
      })
      .addCase(GetScientificDegrees.rejected, (state) => {
        state.isLoadingScientificDegree = false;
      });
  },
});

export const {
  setScientificDegree,
  deletedScientificDegree,
  updateScientificDegree,
  setIsViewScientificDegreesRestore,
  setScientificDegreesRestoreData,
  deletedRestoreScientificDegrees,
  setSelectedScientificDegreeIDs,

} =
    scientificDegreeSlice.actions;

export default scientificDegreeSlice;
